"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.markEventsPerformance = markEventsPerformance;
Object.defineProperty(exports, "Events", {
  enumerable: true,
  get: function () {
    return _Events.Events;
  }
});
Object.defineProperty(exports, "EventsThirdParty", {
  enumerable: true,
  get: function () {
    return _Events.EventsThirdParty;
  }
});
exports.wait = void 0;

var _internal = require("@adobe/exc-app/internal");

var _Events = require("./Events");

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
// Contains the events that should be marked.
var eventsMapping = {}; // Filter function

function metricsWrite(record) {
  if (record.event) {
    var events = Array.isArray(record.event) ? record.event : [record.event];
    events.forEach(function (event) {
      if (event in eventsMapping) {
        window.performance.mark(eventsMapping[event]);
      }
    });
  }

  return Promise.resolve(record);
}
/**
 * Setup the events marker by using the filter approach documented here:
 * https://git.corp.adobe.com/exc/metrics-sdk-js/blob/master/README.md#filter
 * @param eventsToMark An array of events to be marked
 * @param transformFunc a function to transform event names used to enforce a naming convention.
 */


function markEventsPerformance(eventsToMark, transformFunc) {
  if (transformFunc === void 0) {
    transformFunc = function (a) {
      return a;
    };
  }

  eventsToMark.forEach(function (event) {
    eventsMapping[event] = transformFunc(event);
  });

  if (window.performance && typeof window.performance.mark === 'function') {
    _internal.Internal.setFilter(metricsWrite);
  }
}

var wait = function (ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};

exports.wait = wait;